import { defineMessages } from 'react-intl';

const messages = defineMessages({
  basicProjectData: {
    id: 'estimation.detail.managementReport.basicProjectData',
    defaultMessage: 'Basic Project data',
  },
  fields: {
    id: 'estimation.detail.managementReport.fields',
    defaultMessage: 'Fields',
  },
  resourceCostBreakdownSummary: {
    id: 'estimation.detail.managementReport.resourceCostBreakdownSummary',
    defaultMessage: 'Resource Cost Breakdown Summary',
  },
  resourceCostBreakdownDetail: {
    id: 'estimation.detail.managementReport.resourceCostBreakdownDetail',
    defaultMessage: 'Resource Cost Breakdown Detail',
  },
});

export default messages;
